<template>
  <div :class="gameItemClass">
    <div class="px-0">
      <pre :class="gameItemHeaderClass" class="text-center pb-0 font-primary">{{ titleTemp }}</pre>
    </div>
    <div :class="gameItemBodyClass">
      <h4 :class="gameItemTimeEndClass">
        {{ closeAt }}
      </h4>
      <p class="card-text text-center text-lg my-0 py-0">
        <countdown type-countdown="lotto" :seconds-left="secondsLeft" @game-timeout="gameTimeout" />
      </p>
    </div>
    <div class="card-footer bg-white py-2 text-center">
      <a :href="gameLink" :class="gameItemButtonClass">{{ linkText }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SoidownItem',
  props: {
    gameSlug: {
      type: String,
      default: '',
    },
    readableEdition: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    closeAt: {
      type: String,
      default: '',
    },
    secondsLeft: {
      type: Number,
      default: 0,
    },
    gameLink: {
      type: String,
      default: '#',
    },
    status: {
      type: String,
      default: 'open',
    },
  },

  data() {
    return {
      linkLabel: 'แทง',
      gameItemClass: 'card shadow-sm border-success',
      gameItemHeaderClass: 'card-header text-break py-2 bg-success text-white text-center',
      gameItemBodyClass: 'card-body py-2 text-success',
      gameItemTimeEndClass: 'text-xs text-success text-center my-0 py-0',
      gameItemButtonClass: 'btn py-2 btn-success w-100',
      titleTemp: '',
    };
  },

  computed: {
    linkText() {
      return this.linkLabel;
    },
  },
  mounted() {
    if (
      this.gameSlug.search('lotto_') != -1 &&
      this.gameSlug.search('step_') == -1 &&
      this.gameSlug != 'lotto_thai' &&
      this.gameSlug != 'lotto_thai2' &&
      this.gameSlug != 'lotto_baac' &&
      this.gameSlug != 'lotto_gsb'
    ) {
      this.gameItemClass = 'card shadow-sm border-success';
      this.gameItemTimeEndClass = 'text-md text-success text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-success';
      this.gameItemHeaderClass = 'card-header text-break bg-success py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-success w-100 disable';
    } else if (this.gameSlug.search('stock') != -1) {
      this.gameItemClass = 'card shadow-sm border-success';
      this.gameItemTimeEndClass = 'text-md text-success text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-success';
      this.gameItemHeaderClass = 'card-header text-break bg-success py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-success w-100 disable';
    } else if (this.gameSlug.search('soidown') != -1 || this.gameSlug.search('yeekee') != -1) {
      switch (this.gameSlug) {
        case 'soidown_5':
        case 'soidown_10':
        case 'soidown_15':
          // code block
          this.gameItemClass = 'card shadow-sm text-yellow border-yellow';
          this.gameItemTimeEndClass = 'text-md text-yellow text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-yellow ';
          this.gameItemHeaderClass = 'card-header text-break bg-yellow py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-yellow w-100 disable';
          break;
        case 'yeekee_thl_5':
        case 'yeekee_thl_15':
          // code block
          this.gameItemClass = 'card shadow-sm text-orange border-orange';
          this.gameItemTimeEndClass = 'text-md text-orange text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-orange ';
          this.gameItemHeaderClass = 'card-header text-break bg-orange py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-orange w-100 disable';
          break;
        case 'yeekee_lto_5':
        case 'yeekee_lto_15':
          // code block
          this.gameItemClass = 'card shadow-sm text-blue border-blue';
          this.gameItemTimeEndClass = 'text-md text-blue text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-blue ';
          this.gameItemHeaderClass = 'card-header text-break bg-blue py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-blue w-100 disable';
          break;
        case 'yeekee_huay_5':
        case 'yeekee_huay_15':
          // code block
          this.gameItemClass = 'card shadow-sm text-info border-info';
          this.gameItemTimeEndClass = 'text-md text-info text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-info ';
          this.gameItemHeaderClass = 'card-header text-break bg-info py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-info w-100 disable';
          break;
        case 'yeekee_chj_5':
        case 'yeekee_chj_15':
          // code block
          this.gameItemClass = 'card shadow-sm text-primary border-primary';
          this.gameItemTimeEndClass = 'text-md text-primary text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-primary ';
          this.gameItemHeaderClass = 'card-header text-break bg-primary py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-primary w-100 disable';
          break;
        case 'yeekee_dna_5':
        case 'yeekee_dna_15':
          // code block
          this.gameItemClass = 'card shadow-sm text-info border-info';
          this.gameItemTimeEndClass = 'text-md text-info text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-info ';
          this.gameItemHeaderClass = 'card-header text-break bg-info py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-info w-100 disable';
          break;
        case 'soidown_vip':
          // code block
          this.gameItemClass = 'card shadow-sm text-purple border-purple';
          this.gameItemTimeEndClass = 'text-md text-purple text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-purple ';
          this.gameItemHeaderClass = 'card-header text-break bg-purple py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-purple w-100 disable';
          break;
        default:
          // code block
          this.gameItemClass = 'card shadow-sm text-yellow border-yellow';
          this.gameItemTimeEndClass = 'text-md text-yellow text-center my-0 py-0';
          this.gameItemBodyClass = 'card-body py-2 text-yellow ';
          this.gameItemHeaderClass = 'card-header text-break bg-yellow py-2 text-white text-center';
          this.gameItemButtonClass = 'btn py-2 btn-yellow w-100 disable';
      }
    } else if (this.gameSlug.search('step_') != -1) {
      this.gameItemClass = 'card shadow-sm border-danger';
      this.gameItemTimeEndClass = 'text-md text-danger text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-danger';
      this.gameItemHeaderClass = 'card-header text-break bg-danger py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-danger w-100 disable';
    } else if (this.gameSlug.search('huay') != -1) {
      this.gameItemClass = 'card shadow-sm border-blue';
      this.gameItemTimeEndClass = 'text-md text-blue text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-blue';
      this.gameItemHeaderClass = 'card-header text-break bg-blue py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-blue w-100 disable';
    } else if (this.gameSlug.search('jet') != -1) {
      this.gameItemClass = 'card shadow-sm border-orange';
      this.gameItemTimeEndClass = 'text-md text-orange text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-orange';
      this.gameItemHeaderClass = 'card-header text-break bg-orange py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-orange w-100 disable';
    } else if (this.gameSlug.search('lotto_thai') != -1) {
      this.gameItemClass = 'card shadow-sm border-ktb';
      this.gameItemTimeEndClass = 'text-md text-ktb text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-ktb';
      this.gameItemHeaderClass = 'card-header text-break bg-ktb py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-ktb w-100 disable';
    } else if (this.gameSlug.search('lotto_thai2') != -1) {
      this.gameItemClass = 'card shadow-sm border-ktb';
      this.gameItemTimeEndClass = 'text-md text-ktb text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-ktb';
      this.gameItemHeaderClass = 'card-header text-break bg-ktb py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-ktb w-100 disable';
    } else if (this.gameSlug.search('lotto_gsb') != -1) {
      this.gameItemClass = 'card shadow-sm border-gsb';
      this.gameItemTimeEndClass = 'text-md text-gsb text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-gsb';
      this.gameItemHeaderClass = 'card-header text-break bg-gsb py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-gsb w-100 disable';
    } else if (this.gameSlug.search('lotto_baac') != -1) {
      this.gameItemClass = 'card shadow-sm border-baac';
      this.gameItemTimeEndClass = 'text-md text-baac text-center my-0 py-0';
      this.gameItemBodyClass = 'card-body py-2 text-baac';
      this.gameItemHeaderClass = 'card-header text-break bg-baac py-2 text-white text-center';
      this.gameItemButtonClass = 'btn py-2 btn-outline-baac w-100 disable';
    }

    if (this.secondsLeft <= 0) {
      this.linkLabel = 'รอประกาศผล';
      this.gameItemClass = 'card shadow-sm border-gray';
      this.gameItemHeaderClass = 'card-header text-break bg-gray py-2 text-white text-center';
      this.gameItemBodyClass = 'card-body py-2 text-gray';
      this.gameItemTimeEndClass = 'text-md text-gray text-center my-0 py-0';
      this.gameItemButtonClass = 'btn py-2 btn-outline-dark w-100 disable';
    }

    if (this.status == 'pending' || this.status == 'cancel') {
      this.linkLabel = 'ปิดรับแทง';
      this.gameItemClass = 'card shadow-sm border-gray-500';
      this.gameItemHeaderClass = 'card-header text-break bg-gray-500 py-2 text-dark text-center';
      this.gameItemBodyClass = 'card-body py-2 text-dark';
      this.gameItemTimeEndClass = 'text-md text-dark text-center my-0 py-0';
      this.gameItemButtonClass = 'btn py-2 btn-outline-gray w-100 disable';
    }

    if (this.status == 'calculating' || this.status == 'closed') {
      this.linkLabel = 'รอประกาศผล';
      this.gameItemClass = 'card shadow-sm border-gray';
      this.gameItemHeaderClass = 'card-header text-break bg-gray-500 py-2 text-dark text-center';
      this.gameItemBodyClass = 'card-body py-2 text-black bg-white';
      this.gameItemTimeEndClass = 'text-md text-black text-center my-0 py-0';
      this.gameItemButtonClass = 'btn py-2 btn-outline-dark w-100 disable';
    }

    if (this.status == 'complete') {
      this.linkLabel = 'ดูผลรางวัล';
      this.gameItemClass = 'card shadow-sm border-gray';
      this.gameItemHeaderClass = 'card-header text-break bg-gray-500 py-2 text-dark text-center';
      this.gameItemBodyClass = 'card-body py-2 text-black bg-white';
      this.gameItemTimeEndClass = 'text-md text-black text-center my-0 py-0';
      this.gameItemButtonClass = 'btn py-2 btn-danger terxt-white w-100 disable';
    }

    if (this.gameSlug.search('soidown') != -1 || this.gameSlug.search('yeekee') != -1) {
      this.titleTemp = this.title.replace(' วันที่', '\n');
    } else {
      this.titleTemp = this.title.replace(' วันที่', '\n');
    }
  },

  methods: {
    gameTimeout() {
      this.linkLabel = 'รอประกาศผล';
      this.gameItemClass = 'card shadow-sm border-primary';
      this.gameItemHeaderClass = 'card-header text-break py-2 text-dark text-center';
      this.gameItemBodyClass = 'card-body py-2 text-red';
      this.gameItemTimeEndClass = 'text-xs text-red text-center my-0 py-0';
      this.gameItemButtonClass = 'btn py-2 btn-outline-primary w-100 disable';

      this.$emit('game-timeout');
    },
  },
};
</script>
